import { Button, Popconfirm, TableProps, Tag } from "antd";
import { IBettingWebsite } from "../../types/BettingWebsite";
import { IMultiLanguage } from "../../types/MutliLanguage";
import TitlePopOver from "../Articles/Components/TitlePopover";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { BettingWebsiteTop10PopOver } from "./Components/BettingWebsiteTop10PopOver";
import { TbImageInPicture } from "react-icons/tb";
import { CiTrash } from "react-icons/ci";

export interface Top10ArticleTableDataType {
  id: string;
  title: IMultiLanguage;
  image: string;
  keywords: IMultiLanguage[];
  top10List: IBettingWebsite[];
}

export interface Top10RichtTextDataType {
  id: string;
  title: IMultiLanguage;
}

export const Top10RichtTextColumns = (
  articleId: string,
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<Top10RichtTextDataType>["columns"] => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        <TitlePopOver value={record.title} />
      </div>
    ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/top10-articles/manage-rich-text/${articleId}/edit/${
            record.id
          }?page=${page + 1}&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this text?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];

export const Top10ArticlesColumns = (
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<Top10ArticleTableDataType>["columns"] => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        <TitlePopOver value={record.title} />
        <Link
          to={`/top10-articles/edit-title/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },
  {
    title: "Keywords",
    dataIndex: "keywords",
    key: "keywords",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        {record.keywords.map((key: IMultiLanguage) => (
          <Tag
            title={`${key.Ar} - ${key.Fr}`}
            className="flex justify-center items-center"
            color="blue"
          >
            {key.En}
          </Tag>
        ))}
        <Link
          to={`/top10-articles/edit-keywords/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },
  {
    title: "Betting Websites",
    dataIndex: "top10List",
    key: "top10List",
    render: (_, record) => (
      <BettingWebsiteTop10PopOver
        id={record.id}
        page={page}
        pageSize={pageSize}
        websites={record.top10List}
      />
    ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/top10-articles/edit/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Link
          to={`/top10-articles/edit-image/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<TbImageInPicture />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this article?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];
